import { ListItemIcon, ListItemText, Menu, MenuItem, PopoverOrigin } from "@mui/material";
import { DeleteOutline, EditOutlined, InfoOutlined, PreviewOutlined, ShareOutlined } from "@mui/icons-material";
import { FMFile } from "../shared/FMFile";
import { NestedMenuItem } from "mui-nested-menu";

export interface IContextMenu {
    files:FMFile[]
    x:number
    y:number
}

export default function FileMenu(props:{menu:IContextMenu,onClose:any,onDelete:any,onPreview:any,onShare:any}){
    const {files,x,y} = props.menu
    const root = document.querySelector("#main")
    const rect = root!.getBoundingClientRect()
    const onShare = (duration:number) => () => {
        props.onClose()
        props.onShare(files, duration)
    }
    const preview = files.length==1 && (FMFile.isText(files[0]) || FMFile.isImage(files[0])) ? <MenuItem onClick={e=>props.onPreview(files[0])}>
        <ListItemIcon><PreviewOutlined/></ListItemIcon><ListItemText>Preview</ListItemText>
    </MenuItem> : null
    const rename = files.length==1 ? <MenuItem><ListItemIcon><EditOutlined/></ListItemIcon><ListItemText>Rename</ListItemText></MenuItem> : null

    let origin: PopoverOrigin, style: any
    const left = (x - rect.left) + "px"
    if (y-rect.top > rect.height*0.75) {
        origin = {vertical:"bottom", horizontal:"left"}
        style = {left,bottom:(rect.height - rect.top + y) + "px"}
    }
    else {
        origin = {vertical:"top", horizontal:"left"}
        style = {left,top:(y - rect.top) + "px"}
    }

    return <Menu open={true} onClose={props.onClose} anchorEl={root} anchorOrigin={origin} transformOrigin={origin} style={style}>
        {preview}
        <NestedMenuItem label="Share" leftIcon={<ShareOutlined/>} parentMenuOpen={true}>
            <MenuItem onClick={onShare(5)}><ListItemText>5 minutes</ListItemText></MenuItem>
            <MenuItem onClick={onShare(10)}><ListItemText>10 minutes</ListItemText></MenuItem>
            <MenuItem onClick={onShare(60)}><ListItemText>1 hour</ListItemText></MenuItem>
            <MenuItem onClick={onShare(24*60)}><ListItemText>1 day</ListItemText></MenuItem>
        </NestedMenuItem>
        {rename}
        <MenuItem onClick={e=>props.onDelete(files)}>
            <ListItemIcon><DeleteOutline/></ListItemIcon>
            <ListItemText>Delete</ListItemText>
        </MenuItem>
        <MenuItem>
            <ListItemIcon><InfoOutlined/></ListItemIcon>
            <ListItemText>Properties</ListItemText>
        </MenuItem>
    </Menu>
}
